(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/pick', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/pick'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.pick, global.convert);
    global.pick = mod.exports;
  }
})(this, function (exports, _pick2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.pick = undefined;

  var _pick3 = _interopRequireDefault(_pick2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by an object picking specified properties.
   * @function
   * @memberof object
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...(string|string[])} [paths] The property paths to pick.
   * @return {Object} Returns the updated object.
   * @example pick({ nested: { a: 1, b: 2, c: 3 } }, 'nested', 'b') // => { nested: { b: 2 } }
   * @see {@link https://lodash.com/docs#pick|lodash.pick} for more information.
   * @since 0.3.0
   */
  var pick = (0, _convert.convert)(_pick3.default);
  exports.pick = pick;
  exports.default = pick;
});